export default {
  listInventory: [],
};
